<script>
import axios from 'axios';

export default {
  name: 'GoogleOneTap',
  data() {
    return {
      clientId: process.env.MIX_GOOGLE_CLIENT_ID || '',
    };
  },
  mounted() {
    if (!this.clientId) {
      console.warn('GoogleOneTap: Client ID not configured');
      return;
    }

    if (window.googleOneTapInitialized) {
      return;
    }

    window.googleOneTapInitialized = true;

    this.saveOneTapTimestamp();

    this.initGoogleOneTap();
  },
  methods: {
    saveOneTapTimestamp() {
      localStorage.setItem('googleOneTapLastShown', Date.now().toString());
    },
    initGoogleOneTap() {
      if (window.google?.accounts?.id) {
        this.setupGoogleOneTap();
        return;
      }

      const script = document.createElement('script');
      script.src = 'https://accounts.google.com/gsi/client';
      script.async = true;
      script.onload = () => {
        this.setupGoogleOneTap();
      };
      document.head.appendChild(script);
    },
    setupGoogleOneTap() {
      setTimeout(() => {
        window.google?.accounts?.id?.initialize({
          client_id: this.clientId,
          callback: this.handleCredentialResponse,
          use_fedcm_for_prompt: true,
        });

        window.google?.accounts?.id?.prompt();
      }, 500);
    },
    async handleCredentialResponse(response) {
      if (!response.credential) {
        console.error('GoogleOneTap: No credential in response');
        return;
      }

      try {
        const result = await axios.post('/apiv2/social/google-one-tap', {
          credential: response.credential,
        });

        if (result.data.success) {
          const isOnLoginPage = window.location.pathname.startsWith('/user/login');
          if (window.GA4Core && window.GA4Core.trackEvent) {
            window.GA4Core.trackEvent('auth_success', { method: 'google' });
            window.GA4Core.trackEvent('google_prompt_used', { method: 'google' });

            setTimeout(() => {
              if (isOnLoginPage) {
                window.location.href = '/feed';
              } else {
                window.location.reload();
              }
            }, 800);
          } else {
            console.warn('GA4Core not available, reloading without tracking');
            if (isOnLoginPage) {
              window.location.href = '/feed';
            } else {
              window.location.reload();
            }
          }
        }
      } catch (error) {
        if (window?.GA4Core?.trackEvent){
          window.GA4Core.trackEvent('auth_error', { method: 'google' });
        }
        console.error('GoogleOneTap: Backend request error:', error);
      }
    },
  },
};
</script>

<template>
  <div></div>
</template>
